import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex-wrap: nowrap;
  flex-direction: column;
`;

export const FirstItemsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  @media only screen and (max-width: 1000px) {
    grid-template-columns: 3fr;
  }
`;

export const ItemsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  @media only screen and (max-width: 1000px) {
    grid-template-columns: 3fr;
  }
`;

export const HeaderText = styled.h3``;

export const MarginDiv = styled.div`
  margin: 10px;
  background-color: white;
  border-radius: 4px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 25px;
  @media only screen and (max-width: 1000px) {
    margin: 10px;
    padding: 25px;
  }
`;

export const WarningsContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ChartContainer = styled(MarginDiv)``;

export const ChartContainerHeader = styled(HeaderText)``;

export const WarningsContainer = styled(MarginDiv)``;

export const BulletinsContainer = styled(MarginDiv)``;

export const NumbersAtGlanceContainer = styled(MarginDiv)`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const NumbersAtGlanceHeader = styled(HeaderText)``;

export const NumbersAtGlanceTotal = styled.span`
  font: normal normal bold 80px/106px 'Segoe UI';
  letter-spacing: 0px;
  color: #222247;
`;

export const NumbersAtGlanceFooter = styled.div`
  font: normal normal bold 1.6rem Biotif;
  letter-spacing: 0px;
  color: #1a1a32;
`;

export const BenefitsContainer = styled(MarginDiv)``;

export const BenefitsHeaderContainer = styled.div`
  margin-bottom: 5px;
`;

export const BenefitsHeader = styled(HeaderText)`
  margin-bottom: 0;
`;

export const BenefitsSubHeader = styled.span`
  color: #9399b2;
  font: normal normal bold 16px Biotif;
`;

export const ThingsToDoContainer = styled(MarginDiv)``;

export const ThingsToDoHeader = styled(HeaderText)``;

export const ThingsToDoBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
`;

export const ThingsToDoText1 = styled.div`
  font-family: 'BiotifMedium';
`;

export const ThingsToDoText2 = styled.div`
  font: normal normal bold 28px Biotif;
`;

export const YearEndFormsContainer = styled(MarginDiv)``;

export const YearEndFormsHeader = styled(HeaderText)``;

export const YearEndFormsBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: 10px;
  @media only screen and (max-width: 1500px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const ChartSliderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 10px;
`;
